import { render, staticRenderFns } from "./CarbonImportTariffDashboard.vue?vue&type=template&id=79563e8f&"
import script from "./CarbonImportTariffDashboard.vue?vue&type=script&lang=js&"
export * from "./CarbonImportTariffDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports